const tokenKey = "access_token";
const uidKey = "uid";

export function getToken() {
  if (!!localStorage.getItem(tokenKey)) {
    return localStorage.getItem(tokenKey);
  } else if (!!sessionStorage.getItem(tokenKey)) {
    return sessionStorage.getItem(tokenKey);
  } else {
    return null;
  }
}

export function getUID() {
  if (!!localStorage.getItem(uidKey)) {
    return localStorage.getItem(uidKey);
  } else if (!!sessionStorage.getItem(uidKey)) {
    return sessionStorage.getItem(uidKey);
  } else {
    return null;
  }
}

export function getLocalValue(key) {
  if (!!localStorage.getItem(key)) {
    return localStorage.getItem(key);
  } else if (!!sessionStorage.getItem(key)) {
    return sessionStorage.getItem(key);
  } else {
    return null;
  }
}

export function getSessionToken() {
  return sessionStorage.getItem(tokenKey);
}

export function hasToken() {
  return !!getToken();
}

export function setToken(token) {
  localStorage.setItem(tokenKey, token);
}

export function setSessionToken(token) {
  sessionStorage.setItem(tokenKey, token);
}

export function removeToken() {
  localStorage.removeItem(tokenKey);
  sessionStorage.removeItem(tokenKey);
}

export function clearLocalStorage() {
  localStorage.clear();
}

export function clearTokenFromLocalStorage() {
  localStorage.removeItem("access_token");
}
